const ophan = window?.guardian?.ophan;
// ophan helper methods
export const submitComponentEventTracking = (componentEvent) => {
    ophan.record({ componentEvent });
};
export const submitViewEventTracking = (componentEvent) => submitComponentEventTracking({
    ...componentEvent,
    action: 'VIEW',
});
export const submitClickEventTracking = (componentEvent) => submitComponentEventTracking({
    ...componentEvent,
    action: 'CLICK',
});
export const withComponentId = (id = '') => ({
    componentType: 'SIGN_IN_GATE',
    id,
});
export const trackLink = (componentId, value, abTest) => {
    const component = withComponentId(componentId);
    submitClickEventTracking({
        component,
        abTest,
        value,
    });
};
